export type Role = 'admin' | 'repair_station' | 'brazil' | 'naitteng'
export type Language = 'zh' | 'en' | 'pt'
export type OrderStatus = string
export type Priority = 'low' | 'normal' | 'high' | 'urgent'

export interface User {
  id: number
  username: string
  role: Role
  displayName?: string
  display_name?: string
  email: string
  phone?: string
  language: Language
  parent_id?: number | null
  is_active?: number | boolean
}

export interface Order {
  id: number
  order_number: string
  title: string
  description: string
  customer_name: string
  customer_phone?: string
  customer_email?: string
  customer_address?: string
  product_name: string
  product_model?: string
  product_serial?: string
  product_category?: string
  fault_description: string
  fault_category: string
  status: OrderStatus
  previous_status?: OrderStatus
  priority: Priority
  creator_name?: string
  created_by: number
  created_at: string
  updated_at?: string
  closed_at?: string
  assigned_to?: number
}

export interface OrderHistory {
  id: number
  from_status?: OrderStatus
  to_status: OrderStatus
  operator_name?: string
  operator_role: Role
  remark?: string
  created_at: string
}

export interface OrderFile {
  id: number
  file_key: string
  file_name: string
  mime_type: string
  size: number
  created_at: string
}

export interface Part {
  id: number
  part_number: string
  part_name_zh: string
  part_name_en?: string
  part_name_pt?: string
  image_url?: string
}

export interface OrderPart extends Part {
  order_id: number
  part_id: number
  quantity: number
  is_warranty: 0 | 1 | null
}

export interface Vehicle {
  id: number
  vin: string
  model_info?: string
  created_at?: string
}

export interface Warehouse {
  id: number
  name: string
  owner_user_id?: number
  owner_name?: string
}

export interface InventoryItem extends Part {
  warehouse_id: number
  part_id: number
  quantity: number
  updated_at?: string
}

export interface InventoryLog {
  id: number
  part_number: string
  part_name_zh: string
  quantity_change: number
  action_type: 'in' | 'out'
  operator_name?: string
  order_id?: number
  order_number?: string
  remark?: string
  created_at: string
}

export interface InventoryOrderItem extends Part {
  id: number
  order_id: number
  part_id: number
  quantity: number
  actual_quantity: number | null
}

export interface InventoryOrder {
  id: number
  warehouse_id: number
  warehouse_name: string
  status: 'pending' | 'delivered' | 'confirmed'
  creator_name?: string
  created_at: string
  confirmed_at?: string
  items: InventoryOrderItem[]
}

export interface ProcessStep {
  id: number
  step_order: number
  step_name: string
  handler_role: Role
  step_label_zh: string
  step_label_en: string
  step_label_pt: string
  required_fields: string
  editable_fields: string
  notify_roles: string
  is_active: number | boolean
}

export interface FaultType {
  id: number
  code: string
  label_zh: string
  label_en: string
  label_pt: string
  sort_order: number
  is_active: number | boolean
  created_at?: string
  updated_at?: string
}

export interface Paginated<T> {
  total: number
  page: number
  pageSize: number
  orders?: T[]
  parts?: T[]
  vehicles?: T[]
  logs?: T[]
}

export class ApiError extends Error {
  status: number
  payload?: unknown

  constructor(message: string, status: number, payload?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.payload = payload
  }
}
